import { useMutation } from '@apollo/client'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Loader, NotificationType } from '../../components'
import {
  CONFIRM_HOOKS_PAYMENT,
  MutationConfirmHooksPaymentResponse,
  UPDATE_BRAND,
} from '../../gql'
import {
  BrandOnboardingStep,
  MutationConfirmHooksPaymentArgs,
  User,
} from '../../gql/types'
import { trackFirstPurchase, trackPurchase } from '../../utils/analytics'
import { BrandRoutes } from '../BrandRoutes'
import { useNotification } from '../../utils/hooks'

interface IProps {
  user: User
}

const ConfirmVariationsPayment = ({ user }: IProps) => {
  const navigate = useNavigate()
  const { addNotification } = useNotification()

  const [confirmHooksPayment] = useMutation<
    MutationConfirmHooksPaymentResponse,
    MutationConfirmHooksPaymentArgs
  >(CONFIRM_HOOKS_PAYMENT)

  const [updateBrand] = useMutation(UPDATE_BRAND)

  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')
  const redirectUrl: string = searchParams.get('redirectUrl')

  useEffect(() => {
    const confirmPaymentSuccess = async () => {
      try {
        const { data } = await confirmHooksPayment({
          variables: {
            stripeSessionId: sessionId,
          },
        })

        const brand = data.confirmHooksPayment.brand

        // track all purchases and value to be able to optimize for higher value clients
        trackPurchase({
          transactionId: data.confirmHooksPayment.transactionId,
          currency: data.confirmHooksPayment.currency,
          priceCents: data.confirmHooksPayment.priceCents,
          email: user.email,
        })

        // // if brand didn't complete onboarding, this is the first purchase, track it
        // if (brand.onboarding !== BrandOnboardingStep.completed) {
        //   await updateBrand({
        //     variables: {
        //       id: brand.id,
        //       input: {
        //         onboarding: BrandOnboardingStep.completed,
        //       },
        //     },
        //   })

        //   trackFirstPurchase({
        //     transactionId: data.confirmHooksPayment.transactionId,
        //     currency: data.confirmHooksPayment.currency,
        //     priceCents: data.confirmHooksPayment.priceCents,
        //   })
        // }

        navigate(
          redirectUrl ?? BrandRoutes.campaigns.replace(':id', `${brand.id}`),
        )

        addNotification(
          `Your variation(s) order has been confirmed.`,
          NotificationType.success,
        )
      } catch (error) {
        navigate(BrandRoutes.onboarding)
        addNotification(error.message, NotificationType.error)
      }
    }

    if (sessionId) {
      confirmPaymentSuccess()
    }

    if (!sessionId) {
      navigate(BrandRoutes.onboarding)
      addNotification(
        `Invalid url. Looks like you have landed on the wrong page.`,
        NotificationType.error,
      )
    }
  }, [confirmHooksPayment, sessionId, updateBrand])

  return <Loader />
}

export { ConfirmVariationsPayment }
